const enumStatus = Object.freeze({
  ativo: 1,
  inativo: 2,
  excluido: 3,
});

export default enumStatus;

export function getTextStatus(value) {
  switch (value) {
    case enumStatus.ativo:
      return "Ativo";
    case enumStatus.inativo:
      return "Inativo";
    case enumStatus.excluido:
      return "Excluído";
    default:
      return null;
  }
}
